// // // // ----------------------------------------------------------------------

// // // const ROOTS = {
// // //   AUTH: '/auth',
// // //   DASHBOARD: '/dashboard',
// // // };

// // // // ----------------------------------------------------------------------
// // // const resetToken = '';
// // // export const paths = {
// // //   minimalUI: 'https://mui.com/store/items/minimal-dashboard/',
// // //   // AUTH
// // //   auth: {
// // //     jwt: {
// // //       // login: `${ROOTS.AUTH}/jwt/login`,
// // //       // register: `${ROOTS.AUTH}/jwt/register`,
// // //       // reset: `${ROOTS.AUTH}/jwt/reset-password?token=${resetToken}`,
// // //       // forget: `${ROOTS.AUTH}/jwt/forget-password`,
// // //     },
// // //     login: `/login`,
// // //     register: `/register`,
// // //     reset: `/reset-password?token=${resetToken}`,
// // //     forget: `/forget-password`,
// // //   },
// // //   // DASHBOARD
// // //   dashboard: {
// // //     root: ROOTS.DASHBOARD,
// // //     one: `${ROOTS.DASHBOARD}/one`,
// // //     batchs: {
// // //       root: `${ROOTS.DASHBOARD}/batchs`,
// // //       schedule: `${ROOTS.DASHBOARD}/schedule`,
// // //       duration: `${ROOTS.DASHBOARD}/duration`,
// // //     },
// // //     user: {
// // //       root: `${ROOTS.DASHBOARD}/user`,
// // //       profile: `${ROOTS.DASHBOARD}/user/profile`,
// // //     },
// // //     lead: {
// // //       root: `${ROOTS.DASHBOARD}/lead`,
// // //     },
// // //     superadmin: {
// // //       root: `${ROOTS.DASHBOARD}/superadmin`,
// // //     },
// // //     docupdate: {
// // //       root: `${ROOTS.DASHBOARD}/updatedocument`,
// // //     },
// // //     company: {
// // //       root: `${ROOTS.DASHBOARD}/company`,
// // //     },
// // //     timesheet: {
// // //       root: `${ROOTS.DASHBOARD}/timesheet`,
// // //     },
// // //     announcement: {
// // //       root: `${ROOTS.DASHBOARD}/announcement`,
// // //     },
// // //     traierannouncement: {
// // //       root: `${ROOTS.DASHBOARD}/trainer-announcement`,
// // //     },
// // //     task: {
// // //       root: `${ROOTS.DASHBOARD}/task`,
// // //     },
// // //     delegated: {
// // //       root: `${ROOTS.DASHBOARD}/delegated`,
// // //     },
// // //     upatepassword: {
// // //       root: `${ROOTS.DASHBOARD}/upatepassword`,
// // //     },
// // //     placedreview: {
// // //       root: `${ROOTS.DASHBOARD}/placed-review`,
// // //     },
// // //     mockdetails: {
// // //       root: `${ROOTS.DASHBOARD}/mockdetails`,
// // //     },
// // //     role: {
// // //       root: `${ROOTS.DASHBOARD}/role`,
// // //     },
// // //     studentannouncement: {
// // //       root: `${ROOTS.DASHBOARD}/notifications`,
// // //     },
// // //     attendance: {
// // //       root: `${ROOTS.DASHBOARD}/attendance-profile`,
// // //     },
// // //     internalhr: {
// // //       root: `${ROOTS.DASHBOARD}/internal-hr`,
// // //     },
// // //     studentbatch: {
// // //       root: `${ROOTS.DASHBOARD}/student-batch`,
// // //     },
// // //     operationmanagement: {
// // //       root: `${ROOTS.DASHBOARD}/student-update`,
// // //     },
// // //     admin: {
// // //       root: `${ROOTS.DASHBOARD}/admindashboard`,
// // //     },
// // //     eligiblestudent: {
// // //       root: `${ROOTS.DASHBOARD}/interview`,
// // //     },
// // //     placedstudent: {
// // //       root: `${ROOTS.DASHBOARD}/placed-students`,
// // //     },
// // //     trainerdashboard: {
// // //       root: `${ROOTS.DASHBOARD}/trainerdashboard`,
// // //     },
// // //     counsellor: {
// // //       root: `${ROOTS.DASHBOARD}/counsellordashboard`,
// // //     },
// // //     holiday: {
// // //       root: `${ROOTS.DASHBOARD}/holiday`,
// // //     },

// // //     feetype: {
// // //       root: `${ROOTS.DASHBOARD}/payment-installment`,
// // //     },
// // //     studentattendance: {
// // //       root: `${ROOTS.DASHBOARD}/student-attendance`,
// // //     },
// // //     studentattendanceview: {
// // //       root: `${ROOTS.DASHBOARD}/studentattendanceview`,
// // //     },
// // //     reports: {
// // //       root: `${ROOTS.DASHBOARD}/reports`,
// // //     },
// // //     reportenrolled: {
// // //       root: `${ROOTS.DASHBOARD}/reports-enrollment`,
// // //     },
// // //     reportpayment: {
// // //       root: `${ROOTS.DASHBOARD}/reports-payment`,
// // //     },
// // //     reportperformance: {
// // //       root: `${ROOTS.DASHBOARD}/reports-performance`,
// // //     },
// // //     reportperformanceview: {
// // //       root: `${ROOTS.DASHBOARD}/reports-performanceview`,
// // //     },

// // //     setFee: {
// // //       root: `${ROOTS.DASHBOARD}/setFee`,
// // //     },
// // //     trainer: {
// // //       root: `${ROOTS.DASHBOARD}/trainer`,
// // //       profile: `${ROOTS.DASHBOARD}/trainer/profile`,
// // //     },
// // //     students: {
// // //       root: `${ROOTS.DASHBOARD}/students`,
// // //       enquiryprofile: `${ROOTS.DASHBOARD}/students/enquiryprofile`,
// // //       enquiryadd: `${ROOTS.DASHBOARD}/students/enquiryadd`,
// // //       profile: `${ROOTS.DASHBOARD}/students/profile`,
// // //       register: `${ROOTS.DASHBOARD}/students/register`,
// // //       registeradd: `${ROOTS.DASHBOARD}/students/registeradd`,
// // //       registerprofile: `${ROOTS.DASHBOARD}/students/registerprofile`,
// // //     },
// // //     studentassign: {
// // //       root: `${ROOTS.DASHBOARD}/studentassign`,
// // //     },
// // //     enquiry: {
// // //       root: `${ROOTS.DASHBOARD}/enquiry`,
// // //     },
// // //     registration: {
// // //       root: `${ROOTS.DASHBOARD}/registration`,
// // //     },
// // //     subjects: {
// // //       root: `${ROOTS.DASHBOARD}/subjects`,
// // //       subjectadd: `${ROOTS.DASHBOARD}/subjects/subjectadd`,
// // //     },
// // //     course: {
// // //       root: `${ROOTS.DASHBOARD}/course`,
// // //     },
// // //     due: {
// // //       root: `${ROOTS.DASHBOARD}/due`,
// // //     },
// // //     outstanding: {
// // //       root: `${ROOTS.DASHBOARD}/outstanding`,
// // //     },
// // //     upateProfile: {
// // //       root: `${ROOTS.DASHBOARD}/upateProfile`,
// // //     },
// // //     upateBatch: {
// // //       root: `${ROOTS.DASHBOARD}/update-batch`,
// // //     },
// // //     fee: {
// // //       root: `${ROOTS.DASHBOARD}/fee`,
// // //     },
// // //     trainerassignment: {
// // //       root: `${ROOTS.DASHBOARD}/trainer-assignment`,
// // //     },
// // //     checkassignment: {
// // //       root: `${ROOTS.DASHBOARD}/check-assignments`,
// // //     },
// // //     category: {
// // //       root: `${ROOTS.DASHBOARD}/category`,
// // //     },
// // //     mock: {
// // //       root: `${ROOTS.DASHBOARD}/mock`,
// // //     },
// // //     coursemode: {
// // //       root: `${ROOTS.DASHBOARD}/course-mode`,
// // //     },
// // //     status: {
// // //       root: `${ROOTS.DASHBOARD}/status`,
// // //     },
// // //     counsellors: {
// // //       root: `${ROOTS.DASHBOARD}/counsellor`,
// // //     },
// // //     paymentmodes: {
// // //       root: `${ROOTS.DASHBOARD}/payment-modes`,
// // //     },
// // //     paymentbanks: {
// // //       root: `${ROOTS.DASHBOARD}/payment-banks`,
// // //     },
// // //     aboutus: {
// // //       root: `${ROOTS.DASHBOARD}/about-us`,
// // //     },
// // //     work_experience: {
// // //       root: `${ROOTS.DASHBOARD}/work-experience`,
// // //     },
// // //   },
// // // };
// // // ----------------------------------------------------------------------

// // const ROOTS = {
// //   AUTH: '/auth',
// //   DASHBOARD: '/dashboard',
// // };

// // // ----------------------------------------------------------------------
// // const resetToken = '';
// // export const paths = {
// //   minimalUI: 'https://mui.com/store/items/minimal-dashboard/',
// //   // AUTH
// //   auth: {
// //     jwt: {
// //       // login: `${ROOTS.AUTH}/jwt/login`,
// //       // register: `${ROOTS.AUTH}/jwt/register`,
// //       // reset: `${ROOTS.AUTH}/jwt/reset-password?token=${resetToken}`,
// //       // forget: `${ROOTS.AUTH}/jwt/forget-password`,
// //     },
// //     login: `/login`,
// //     register: `/register`,
// //     reset: `/reset-password?token=${resetToken}`,
// //     forget: `/forget-password`,
// //   },
// //   // DASHBOARD
// //   dashboard: {
// //     root: ROOTS.DASHBOARD,
// //     one: `${ROOTS.DASHBOARD}/one`,
// //     batchs: {
// //       root: `${ROOTS.DASHBOARD}/batchs`,
// //       schedule: `${ROOTS.DASHBOARD}/schedule`,
// //       duration: `${ROOTS.DASHBOARD}/duration`,
// //     },
// //     user: {
// //       root: `${ROOTS.DASHBOARD}/user`,
// //       profile: `${ROOTS.DASHBOARD}/user/profile`,
// //     },
// //     lead: {
// //       root: `${ROOTS.DASHBOARD}/lead`,
// //     },
// //     superadmin: {
// //       root: `${ROOTS.DASHBOARD}/superadmin`,
// //     },
// //     docupdate: {
// //       root: `${ROOTS.DASHBOARD}/updatedocument`,
// //     },
// //     company: {
// //       root: `${ROOTS.DASHBOARD}/company`,
// //     },
// //     timesheet: {
// //       root: `${ROOTS.DASHBOARD}/timesheet`,
// //     },
// //     announcement: {
// //       root: `${ROOTS.DASHBOARD}/announcement`,
// //     },
// //     jobpost: {
// //       root: `${ROOTS.DASHBOARD}/jobpost`,
// //     },
// //     traierannouncement: {
// //       root: `${ROOTS.DASHBOARD}/trainer-announcement`,
// //     },
// //     task: {
// //       root: `${ROOTS.DASHBOARD}/task`,
// //     },
// //     delegated: {
// //       root: `${ROOTS.DASHBOARD}/delegated`,
// //     },
// //     upatepassword: {
// //       root: `${ROOTS.DASHBOARD}/upatepassword`,
// //     },
// //     placedreview: {
// //       root: `${ROOTS.DASHBOARD}/placed-review`,
// //     },
// //     mockdetails: {
// //       root: `${ROOTS.DASHBOARD}/mockdetails`,
// //     },
// //     role: {
// //       root: `${ROOTS.DASHBOARD}/role`,
// //     },
// //     studentannouncement: {
// //       root: `${ROOTS.DASHBOARD}/notifications`,
// //     },
// //     attendance: {
// //       root: `${ROOTS.DASHBOARD}/attendance-profile`,
// //     },
// //     internalhr: {
// //       root: `${ROOTS.DASHBOARD}/internal-hr`,
// //     },
// //     studentbatch: {
// //       root: `${ROOTS.DASHBOARD}/student-batch`,
// //     },
// //     operationmanagement: {
// //       root: `${ROOTS.DASHBOARD}/student-update`,
// //     },
// //     admin: {
// //       root: `${ROOTS.DASHBOARD}/admindashboard`,
// //     },
// //     eligiblestudent: {
// //       root: `${ROOTS.DASHBOARD}/interview`,
// //     },
// //     placedstudent: {
// //       root: `${ROOTS.DASHBOARD}/placed-students`,
// //     },
// //     trainerdashboard: {
// //       root: `${ROOTS.DASHBOARD}/trainerdashboard`,
// //     },
// //     counsellor: {
// //       root: `${ROOTS.DASHBOARD}/counsellordashboard`,
// //     },
// //     holiday: {
// //       root: `${ROOTS.DASHBOARD}/holiday`,
// //     },

// //     feetype: {
// //       root: `${ROOTS.DASHBOARD}/payment-installment`,
// //     },
// //     studentattendance: {
// //       root: `${ROOTS.DASHBOARD}/student-attendance`,
// //     },
// //     studentattendanceview: {
// //       root: `${ROOTS.DASHBOARD}/studentattendanceview`,
// //     },
// //     reports: {
// //       root: `${ROOTS.DASHBOARD}/reports`,
// //     },
// //     reportenrolled: {
// //       root: `${ROOTS.DASHBOARD}/reports-enrollment`,
// //     },
// //     reportpayment: {
// //       root: `${ROOTS.DASHBOARD}/reports-payment`,
// //     },
// //     reportperformance: {
// //       root: `${ROOTS.DASHBOARD}/reports-performance`,
// //     },
// //     reportperformanceview: {
// //       root: `${ROOTS.DASHBOARD}/reports-performanceview`,
// //     },

// //     setFee: {
// //       root: `${ROOTS.DASHBOARD}/setFee`,
// //     },
// //     trainer: {
// //       root: `${ROOTS.DASHBOARD}/trainer`,
// //       profile: `${ROOTS.DASHBOARD}/trainer/profile`,
// //     },
// //     students: {
// //       root: `${ROOTS.DASHBOARD}/students`,
// //       enquiryprofile: `${ROOTS.DASHBOARD}/students/enquiryprofile`,
// //       enquiryadd: `${ROOTS.DASHBOARD}/students/enquiryadd`,
// //       profile: `${ROOTS.DASHBOARD}/students/profile`,
// //       register: `${ROOTS.DASHBOARD}/students/register`,
// //       registeradd: `${ROOTS.DASHBOARD}/students/registeradd`,
// //       registerprofile: `${ROOTS.DASHBOARD}/students/registerprofile`,
// //     },
// //     studentassign: {
// //       root: `${ROOTS.DASHBOARD}/studentassign`,
// //     },
// //     enquiry: {
// //       root: `${ROOTS.DASHBOARD}/enquiry`,
// //     },
// //     registration: {
// //       root: `${ROOTS.DASHBOARD}/registration`,
// //     },
// //     subjects: {
// //       root: `${ROOTS.DASHBOARD}/subjects`,
// //       subjectadd: `${ROOTS.DASHBOARD}/subjects/subjectadd`,
// //     },
// //     course: {
// //       root: `${ROOTS.DASHBOARD}/course`,
// //     },
// //     due: {
// //       root: `${ROOTS.DASHBOARD}/due`,
// //     },
// //     outstanding: {
// //       root: `${ROOTS.DASHBOARD}/outstanding`,
// //     },
// //     upateProfile: {
// //       root: `${ROOTS.DASHBOARD}/upateProfile`,
// //     },
// //     upateBatch: {
// //       root: `${ROOTS.DASHBOARD}/update-batch`,
// //     },
// //     fee: {
// //       root: `${ROOTS.DASHBOARD}/fee`,
// //     },
// //     trainerassignment: {
// //       root: `${ROOTS.DASHBOARD}/trainer-assignment`,
// //     },
// //     checkassignment: {
// //       root: `${ROOTS.DASHBOARD}/check-assignments`,
// //     },
// //     category: {
// //       root: `${ROOTS.DASHBOARD}/category`,
// //     },
// //     mock: {
// //       root: `${ROOTS.DASHBOARD}/mock`,
// //     },
// //     coursemode: {
// //       root: `${ROOTS.DASHBOARD}/course-mode`,
// //     },
// //     status: {
// //       root: `${ROOTS.DASHBOARD}/status`,
// //     },
// //     counsellors: {
// //       root: `${ROOTS.DASHBOARD}/counsellor`,
// //     },
// //     paymentmodes: {
// //       root: `${ROOTS.DASHBOARD}/payment-modes`,
// //     },
// //     paymentbanks: {
// //       root: `${ROOTS.DASHBOARD}/payment-banks`,
// //     },
// //     aboutus: {
// //       root: `${ROOTS.DASHBOARD}/about-us`,
// //     },
// //     work_experience: {
// //       root: `${ROOTS.DASHBOARD}/work-experience`,
// //     },
// //   },
// // };
// // ----------------------------------------------------------------------

// const ROOTS = {
//   AUTH: '/auth',
//   DASHBOARD: '/dashboard',
// };

// // ----------------------------------------------------------------------
// const resetToken = '';
// export const paths = {
//   minimalUI: 'https://mui.com/store/items/minimal-dashboard/',
//   // AUTH
//   auth: {
//     jwt: {
//       // login: `${ROOTS.AUTH}/jwt/login`,
//       // register: `${ROOTS.AUTH}/jwt/register`,
//       // reset: `${ROOTS.AUTH}/jwt/reset-password?token=${resetToken}`,
//       // forget: `${ROOTS.AUTH}/jwt/forget-password`,
//     },
//     login: `/login`,
//     register: `/register`,
//     reset: `/reset-password?token=${resetToken}`,
//     forget: `/forget-password`,
//   },
//   // DASHBOARD
//   dashboard: {
//     root: ROOTS.DASHBOARD,
//     one: `${ROOTS.DASHBOARD}/one`,
//     batchs: {
//       root: `${ROOTS.DASHBOARD}/batchs`,
//       schedule: `${ROOTS.DASHBOARD}/schedule`,
//       duration: `${ROOTS.DASHBOARD}/duration`,
//     },
//     user: {
//       root: `${ROOTS.DASHBOARD}/user`,
//       profile: `${ROOTS.DASHBOARD}/user/profile`,
//     },
//     lead: {
//       root: `${ROOTS.DASHBOARD}/lead`,
//     },
//     superadmin: {
//       root: `${ROOTS.DASHBOARD}/superadmin`,
//     },
//     docupdate: {
//       root: `${ROOTS.DASHBOARD}/updatedocument`,
//     },
//     company: {
//       root: `${ROOTS.DASHBOARD}/company`,
//     },
//     timesheet: {
//       root: `${ROOTS.DASHBOARD}/timesheet`,
//     },
//     announcement: {
//       root: `${ROOTS.DASHBOARD}/announcement`,
//     },
//     jobpost: {
//       root: `${ROOTS.DASHBOARD}/jobpost`,
//     },
//     traierannouncement: {
//       root: `${ROOTS.DASHBOARD}/trainer-announcement`,
//     },
//     task: {
//       root: `${ROOTS.DASHBOARD}/task`,
//     },
//     delegated: {
//       root: `${ROOTS.DASHBOARD}/delegated`,
//     },
//     upatepassword: {
//       root: `${ROOTS.DASHBOARD}/upatepassword`,
//     },
//     placedreview: {
//       root: `${ROOTS.DASHBOARD}/placed-review`,
//     },
//     mockdetails: {
//       root: `${ROOTS.DASHBOARD}/mockdetails`,
//     },
//     role: {
//       root: `${ROOTS.DASHBOARD}/role`,
//     },
//     studentannouncement: {
//       root: `${ROOTS.DASHBOARD}/notifications`,
//     },
//     attendance: {
//       root: `${ROOTS.DASHBOARD}/attendance-profile`,
//     },
//     internalhr: {
//       root: `${ROOTS.DASHBOARD}/internal-hr`,
//     },
//     studentbatch: {
//       root: `${ROOTS.DASHBOARD}/student-batch`,
//     },
//     operationmanagement: {
//       root: `${ROOTS.DASHBOARD}/student-update`,
//     },
//     admin: {
//       root: `${ROOTS.DASHBOARD}/admindashboard`,
//     },
//     eligiblestudent: {
//       root: `${ROOTS.DASHBOARD}/interview`,
//     },
//     placedstudent: {
//       root: `${ROOTS.DASHBOARD}/placed-students`,
//     },
//     trainerdashboard: {
//       root: `${ROOTS.DASHBOARD}/trainerdashboard`,
//     },
//     counsellor: {
//       root: `${ROOTS.DASHBOARD}/counsellordashboard`,
//     },
//     holiday: {
//       root: `${ROOTS.DASHBOARD}/holiday`,
//     },

//     feetype: {
//       root: `${ROOTS.DASHBOARD}/payment-installment`,
//     },
//     studentattendance: {
//       root: `${ROOTS.DASHBOARD}/student-attendance`,
//     },
//     studentattendanceview: {
//       root: `${ROOTS.DASHBOARD}/studentattendanceview`,
//     },
//     reports: {
//       root: `${ROOTS.DASHBOARD}/reports`,
//     },
//     reportenrolled: {
//       root: `${ROOTS.DASHBOARD}/reports-enrollment`,
//     },
//     reportpayment: {
//       root: `${ROOTS.DASHBOARD}/reports-payment`,
//     },
//     reportperformance: {
//       root: `${ROOTS.DASHBOARD}/reports-performance`,
//     },
//     reportperformanceview: {
//       root: `${ROOTS.DASHBOARD}/reports-performanceview`,
//     },

//     setFee: {
//       root: `${ROOTS.DASHBOARD}/setFee`,
//     },
//     trainer: {
//       root: `${ROOTS.DASHBOARD}/trainer`,
//       profile: `${ROOTS.DASHBOARD}/trainer/profile`,
//     },
//     students: {
//       root: `${ROOTS.DASHBOARD}/students`,
//       enquiryprofile: `${ROOTS.DASHBOARD}/students/enquiryprofile`,
//       enquiryadd: `${ROOTS.DASHBOARD}/students/enquiryadd`,
//       profile: `${ROOTS.DASHBOARD}/students/profile`,
//       register: `${ROOTS.DASHBOARD}/students/register`,
//       registeradd: `${ROOTS.DASHBOARD}/students/registeradd`,
//       registerprofile: `${ROOTS.DASHBOARD}/students/registerprofile`,
//     },
//     studentassign: {
//       root: `${ROOTS.DASHBOARD}/studentassign`,
//     },
//     enquiry: {
//       root: `${ROOTS.DASHBOARD}/enquiry`,
//     },
//     registration: {
//       root: `${ROOTS.DASHBOARD}/registration`,
//     },
//     subjects: {
//       root: `${ROOTS.DASHBOARD}/subjects`,
//       subjectadd: `${ROOTS.DASHBOARD}/subjects/subjectadd`,
//     },
//     course: {
//       root: `${ROOTS.DASHBOARD}/course`,
//     },
//     due: {
//       root: `${ROOTS.DASHBOARD}/due`,
//     },
//     outstanding: {
//       root: `${ROOTS.DASHBOARD}/outstanding`,
//     },
//     upateProfile: {
//       root: `${ROOTS.DASHBOARD}/upateProfile`,
//     },
//     upateBatch: {
//       root: `${ROOTS.DASHBOARD}/update-batch`,
//     },
//     fee: {
//       root: `${ROOTS.DASHBOARD}/fee`,
//     },
//     trainerassignment: {
//       root: `${ROOTS.DASHBOARD}/trainer-assignment`,
//     },
//     checkassignment: {
//       root: `${ROOTS.DASHBOARD}/check-assignments`,
//     },
//     category: {
//       root: `${ROOTS.DASHBOARD}/category`,
//     },
//     mock: {
//       root: `${ROOTS.DASHBOARD}/mock`,
//     },
//     coursemode: {
//       root: `${ROOTS.DASHBOARD}/course-mode`,
//     },
//     status: {
//       root: `${ROOTS.DASHBOARD}/status`,
//     },
//     counsellors: {
//       root: `${ROOTS.DASHBOARD}/counsellor`,
//     },
//     paymentmodes: {
//       root: `${ROOTS.DASHBOARD}/payment-modes`,
//     },
//     paymentbanks: {
//       root: `${ROOTS.DASHBOARD}/payment-banks`,
//     },
//     aboutus: {
//       root: `${ROOTS.DASHBOARD}/about-us`,
//     },
//     work_experience: {
//       root: `${ROOTS.DASHBOARD}/work-experience`,
//     },
//   },
// };
// ----------------------------------------------------------------------

const ROOTS = {
  AUTH: '/auth',
  DASHBOARD: '/dashboard',
};

// ----------------------------------------------------------------------
const resetToken = '';
export const paths = {
  minimalUI: 'https://mui.com/store/items/minimal-dashboard/',
  // AUTH
  auth: {
    jwt: {
      // login: `${ROOTS.AUTH}/jwt/login`,
      // register: `${ROOTS.AUTH}/jwt/register`,
      // reset: `${ROOTS.AUTH}/jwt/reset-password?token=${resetToken}`,
      // forget: `${ROOTS.AUTH}/jwt/forget-password`,
    },
    login: `/login`,
    register: `/register`,
    reset: `/reset-password?token=${resetToken}`,
    forget: `/forget-password`,
    

  },
  // DASHBOARD
  dashboard: {
    root: ROOTS.DASHBOARD,
    one: `${ROOTS.DASHBOARD}/one`,
    batchs: {
      root: `${ROOTS.DASHBOARD}/batchs`,
      schedule: `${ROOTS.DASHBOARD}/schedule`,
      duration: `${ROOTS.DASHBOARD}/duration`,
    },
    user: {
      root: `${ROOTS.DASHBOARD}/user`,
      profile: `${ROOTS.DASHBOARD}/user/profile`,
    },
    lead: {
      root: `${ROOTS.DASHBOARD}/lead`,
    },
    superadmin: {
      root: `${ROOTS.DASHBOARD}/superadmin`,
    },
    docupdate: {
      root: `${ROOTS.DASHBOARD}/updatedocument`,
    },
    company: {
      root: `${ROOTS.DASHBOARD}/company`,
    },
    timesheet: {
      root: `${ROOTS.DASHBOARD}/timesheet`,
    },
    announcement: {
      root: `${ROOTS.DASHBOARD}/announcement`,
    },
    jobpost: {
      root: `${ROOTS.DASHBOARD}/jobpost`,
    },
    traierannouncement: {
      root: `${ROOTS.DASHBOARD}/trainer-announcement`,
    },
    task: {
      root: `${ROOTS.DASHBOARD}/task`,
    },
    delegated: {
      root: `${ROOTS.DASHBOARD}/delegated`,
    },
    upatepassword: {
      root: `${ROOTS.DASHBOARD}/upatepassword`,
    },
    placedreview: {
      root: `${ROOTS.DASHBOARD}/placed-review`,
    },
    mockdetails: {
      root: `${ROOTS.DASHBOARD}/mockdetails`,
    },
    role: {
      root: `${ROOTS.DASHBOARD}/role`,
    },
    studentannouncement: {
      root: `${ROOTS.DASHBOARD}/notifications`,
    },
    attendance: {
      root: `${ROOTS.DASHBOARD}/attendance-profile`,
    },
    internalhr: {
      root: `${ROOTS.DASHBOARD}/internal-hr`,
    },
    studentbatch: {
      root: `${ROOTS.DASHBOARD}/student-batch`,
    },
    preferredlocation: {
      root: `${ROOTS.DASHBOARD}/preferred-location`,
    },
    operationmanagement: {
      root: `${ROOTS.DASHBOARD}/student-update`,
    },
    admin: {
      root: `${ROOTS.DASHBOARD}/admindashboard`,
    },
    eligiblestudent: {
      root: `${ROOTS.DASHBOARD}/interview`,
    },
    placedstudent: {
      root: `${ROOTS.DASHBOARD}/placed-students`,
    },
    trainerdashboard: {
      root: `${ROOTS.DASHBOARD}/trainerdashboard`,
    },
    counsellor: {
      root: `${ROOTS.DASHBOARD}/counsellordashboard`,
    },
    holiday: {
      root: `${ROOTS.DASHBOARD}/holiday`,
    },

    feetype: {
      root: `${ROOTS.DASHBOARD}/payment-installment`,
    },
    studentattendance: {
      root: `${ROOTS.DASHBOARD}/attendance-profile`,
    },
    studentattendanceview: {
      root: `${ROOTS.DASHBOARD}/studentattendanceview`,
    },
    reports: {
      root: `${ROOTS.DASHBOARD}/reports`,
    },
    reportenrolled: {
      root: `${ROOTS.DASHBOARD}/reports-enrollment`,
    },
    reportreview: {
      root: `${ROOTS.DASHBOARD}/reports-review`,
    },
    helpdesk: {
      root: `${ROOTS.DASHBOARD}/helpdesk`,
    },
    reportpayment: {
      root: `${ROOTS.DASHBOARD}/reports-payment`,
    },
    reportperformance: {
      root: `${ROOTS.DASHBOARD}/reports-performance`,
    },
    reportperformanceview: {
      root: `${ROOTS.DASHBOARD}/reports-performanceview`,
    },

    setFee: {
      root: `${ROOTS.DASHBOARD}/setFee`,
    },
    trainer: {
      root: `${ROOTS.DASHBOARD}/trainer`,
      profile: `${ROOTS.DASHBOARD}/trainer/profile`,
    },
    mentor: {
      root: `${ROOTS.DASHBOARD}/mentor`,
      profile: `${ROOTS.DASHBOARD}/mentor/profile`,
    },
    reward: {
      root: `${ROOTS.DASHBOARD}/reward`,
    },
    applications: {
      root: `${ROOTS.DASHBOARD}/applications`,
    },
    qa: {
      root: `${ROOTS.DASHBOARD}/question_answer`,
    },
    students: {
      root: `${ROOTS.DASHBOARD}/students`,
      enquiryprofile: `${ROOTS.DASHBOARD}/students/enquiryprofile`,
      enquiryadd: `${ROOTS.DASHBOARD}/students/enquiryadd`,
      profile: `${ROOTS.DASHBOARD}/students/profile`,
      register: `${ROOTS.DASHBOARD}/students/register`,
      registeradd: `${ROOTS.DASHBOARD}/students/registeradd`,
      registerprofile: `${ROOTS.DASHBOARD}/students/registerprofile`,
    },
    studentassign: {
      root: `${ROOTS.DASHBOARD}/studentassign`,
    },
    enquiry: {
      root: `${ROOTS.DASHBOARD}/enquiry`,
    },
    registration: {
      root: `${ROOTS.DASHBOARD}/registration`,
    },
    subjects: {
      root: `${ROOTS.DASHBOARD}/subjects`,
      subjectadd: `${ROOTS.DASHBOARD}/subjects/subjectadd`,
    },
    course: {
      root: `${ROOTS.DASHBOARD}/course`,
    },
    due: {
      root: `${ROOTS.DASHBOARD}/due`,
    },
    outstanding: {
      root: `${ROOTS.DASHBOARD}/outstanding`,
    },
    upateProfile: {
      root: `${ROOTS.DASHBOARD}/upateProfile`,
    },
    upateBatch: {
      root: `${ROOTS.DASHBOARD}/update-batch`,
    },
    fee: {
      root: `${ROOTS.DASHBOARD}/fee`,
    },
    trainerassignment: {
      root: `${ROOTS.DASHBOARD}/trainer-assignment`,
    },
    checkassignment: {
      root: `${ROOTS.DASHBOARD}/check-assignments`,
    },
    category: {
      root: `${ROOTS.DASHBOARD}/category`,
    },
    mock: {
      root: `${ROOTS.DASHBOARD}/mock`,
    },
     mails: {
      root: `${ROOTS.DASHBOARD}/mails`,
    },
      pages: {
      root: `${ROOTS.DASHBOARD}/pages`,
    },
    coursemode: {
      root: `${ROOTS.DASHBOARD}/course-mode`,
    },
    status: {
      root: `${ROOTS.DASHBOARD}/status`,
    },
    counsellors: {
      root: `${ROOTS.DASHBOARD}/counsellor`,
    },
    paymentmodes: {
      root: `${ROOTS.DASHBOARD}/payment-modes`,
    },
    zoom_accounts: {
      root: `${ROOTS.DASHBOARD}/zoom-accounts`,
    },
     zoom_details: {
      root: `${ROOTS.DASHBOARD}/zoom-meets`,
    },
    paymentbanks: {
      root: `${ROOTS.DASHBOARD}/payment-banks`,
    },
    aboutus: {
      root: `${ROOTS.DASHBOARD}/about-us`,
    },
    work_experience: {
      root: `${ROOTS.DASHBOARD}/work-experience`,
    },
  },
};
